import { render } from "./AppLoading.vue?vue&type=template&id=11a276a0&ts=true"
import script from "./AppLoading.vue?vue&type=script&lang=ts"
export * from "./AppLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__